module.exports = __webpack_public_path__ + "img/powderedMilk.6d2662bf.png";